import { useQuery } from '@tanstack/react-query'

import type { UseQueryResult } from '@tanstack/react-query'
import type { INotionBlock } from '~/types/notion'

import { getNotionPage } from '~/api/notion'

////////// KEYS //////////
export const keys = {
  all: ['changelogs'] as const,
  details: (pageId?: string) => [...keys.all, 'details', pageId] as const,
}

////////// QUERIES //////////
export const useNotionPageQuery = (pageId?: string): UseQueryResult<INotionBlock, unknown> => {
  return useQuery({
    enabled: !!pageId,
    queryFn: () => getNotionPage(pageId as string),
    queryKey: keys.details(pageId as string),
  })
}
